<template>
  <!-- Date and IP address -->
  <div class="anz-post__header-date anz-small" data-cy="post-created-at">
    <ul class="anz-inline-list-bar anz-inline-list-bar--sm anz-color-gray-600">
      <li>
        <div
          class="anz-text-nowrap"
          v-if="configuration.widget.postDateLinkDisabled"
        >
          <template v-if="postRoot.post.modified">
            <span :title="$translate('post.model.modified')">
              {{ modifiedAtFormatted() }}
              <a-icon
                name="edit"
                width="0.8928em"
                height="0.8928em"
                class-name="anz-ml-xxs"
              />
            </span>
          </template>
          <template v-else>
            {{ dateTimeFormatted() }}
          </template>
        </div>
        <a-button
          add-href
          v-else
          :href="generatePostRoute(postRoot.post)"
          className="anz-link anz-text-nowrap anz-color-gray-600"
          :tooltip-title="
            postRoot.post.modified ? $translate('post.model.modified') : ''
          "
        >
          <template #title>
            <template v-if="postRoot.post.modified">
              {{ modifiedAtFormatted() }}
              <a-icon
                name="edit"
                width="0.8928em"
                height="0.8928em"
                class-name="anz-ml-xxs"
              />
            </template>
            <template v-else>
              {{ dateTimeFormatted() }}
            </template>
          </template>
        </a-button>
      </li>
      <li v-if="showIp">
        <span class="anz-color-black-30">
          {{
            $translate('post.texts.ipAddress') + ' ' + postRoot.post.ipAddress
          }}
        </span>
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import AButton from '@/components/Forms/AButton.vue'
import { useRouter } from '@/routing/router'
import useAppState from '@/composables/ui/ui'
import { PostsRoot } from '@/composables/post/postList'
import useConfiguration from '@/composables/configuration/configuration'
import { DateTimeHelper } from '@/helper/dateTime'
import AIcon from '@/components/AIcon.vue'

export default defineComponent({
  name: 'PostInformation',
  emits: ['toggle-edit-form'],
  components: { AIcon, AButton },
  props: {
    postRoot: {
      type: PostsRoot,
      required: true,
    },
    showIp: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    modifiedAtFormatted() {
      if (this.postRoot.post && this.postRoot.post.editedAt) {
        return DateTimeHelper.formatDateTime(this.postRoot.post.editedAt)
      }

      return ''
    },
    dateTimeFormatted() {
      if (this.postRoot.post) {
        return DateTimeHelper.formatDateTime(this.postRoot.post.createdAt)
      }

      return ''
    },
  },
  setup() {
    return {
      ...useConfiguration(),
      ...useRouter(),
      ...useAppState(),
    }
  },
})
</script>
